module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-600.d6b9e540.svg";